import { render } from "./user-wishlist.vue?vue&type=template&id=a8014b7a"
import script from "./user-wishlist.vue?vue&type=script&lang=js"
export * from "./user-wishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__